import React, { useEffect, useState } from 'react';
import { FaAngleUp } from "react-icons/fa";
import styled from 'styled-components';

//Boton principal para ir al principio de la página
export default function AnimacionScroll() {

    const ScrollToTopButton = styled.a`
  border-radius: 4px;
  bottom: ${props => props.is_visible ? '100px' : '-50px'}; /* Cambia la posición basada en si es visible o no */
  color: #fff;
  display: flex; /* Usar flexbox para centrar verticalmente */
  align-items: center; /* Centrar verticalmente el contenido */
  justify-content: center; /* Centrar horizontalmente el contenido */
  font-size: 30px;
  line-height: 45px;
  height: 45px;
  font-size: 18px;
  font-family: "Montserrat", sans-serif;
  padding: 10px 0;
  position: fixed;
  right: 20px;
  text-align: center;
  text-decoration: none;
  width: 50px;
  z-index: 999;
  background-color: #EE805D; /* Cambia el color de fondo a #EE805D */
  transition: bottom 0.3s ease; /* Agrega una transición suave */
`;

    const [is_visible, setis_visible] = useState(false);

    // Maneja el evento scroll para mostrar u ocultar el botón
    const handleScroll = () => {
        if (window.scrollY > 100) {
            setis_visible(true);
        } else {
            setis_visible(false);
        }
    };

    // Agrega el listener de scroll cuando se monta el componente
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll); // Limpia el listener cuando el componente se desmonta
    }, []);

    // Función para hacer scroll suave hacia arriba
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <ScrollToTopButton href="#" is_visible={is_visible ? 'true' : 'false'} onClick={scrollToTop}>
            <FaAngleUp />
        </ScrollToTopButton>)
}
